import cloneDateTime from './cloneDateTime';

let getPreviousMonthMemoKey;
let getPreviousMonthMemoValue;

export default function getPreviousMonthMemoLast(month) {
  if (month !== getPreviousMonthMemoKey) {
    getPreviousMonthMemoKey = month;
    getPreviousMonthMemoValue = cloneDateTime(month).minus({ months: 1 });
  }

  return getPreviousMonthMemoValue;
}
